import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint, theme } from '../../../theme';
export const subNavigationItemActiveClassName = 'active';

export type SubNavigationItemProps = PropsWithChildren<{
  activeClassName?: string;
  disabled?: boolean;
}>;

const SubNavItemLinkStyles = css`
  text-decoration: none;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-bottom-color: transparent;
  padding-bottom: ${theme.spacings[3].rem};

  ${breakpoint('lg')`
    padding-bottom: ${theme.spacings[5].rem};
  `};
`;

const StyledSubNavItem = styled.li<SubNavigationItemProps>`
  margin: 0 ${theme.spacings[2].rem};
  padding: ${theme.spacings[4].rem} 0;
  white-space: nowrap;

  a {
    transition: color 200ms ease-in, border-bottom-color 200ms ease-in;
    ${theme.typography.headings[6]['sm-lg']};
    color: ${({ disabled }) =>
      disabled
        ? theme.colors.neutrals.solidGrays[3]
        : theme.colors.primary.graysGray};
    ${SubNavItemLinkStyles}

    ${({ activeClassName, disabled }) =>
      !disabled &&
      `&.${activeClassName}, &:hover {
        color: ${theme.colors.primary.graysGray};
        border-bottom-color: ${theme.colors.primary.graysGray};
      }`}
  }

  &:last-child {
    padding-right: ${theme.spacings[3].rem};
  }

  ${breakpoint('lg')`
    margin: 0 ${theme.spacings[4].rem};
    padding: ${theme.spacings[4].rem} 0;
  `};
`;

export const SubNavigationItem: React.FC<SubNavigationItemProps> = ({
  activeClassName = subNavigationItemActiveClassName,
  disabled = false,
  children,
}) => (
  <StyledSubNavItem activeClassName={activeClassName} disabled={disabled}>
    {children}
  </StyledSubNavItem>
);
